import { Injectable } from '@angular/core';

import {ForuscareService} from '../foruscare/foruscare.service';

import { HttpClient } from '@angular/common/http';
import { HttpErrorHandlerService, HandleError } from '../shared/http-error-handler.service';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TelecareServiceService {

  private handleError: HandleError;
  constructor(
    public http: HttpClient,
    public fourscareService: ForuscareService,
    httpErrorHandler: HttpErrorHandlerService) {
    this.handleError = httpErrorHandler.createHandleError('Telecare Dashboard Service');
  }
  
  getAppointmentDashboardDataByDateRange(startDate,endDate,doctorId): any {
    return this.http.get<any>(this.fourscareService.baseTelecareURL() + "/dashboard/getAppointmentStatistics/"+startDate+"/"+endDate+"/"+doctorId)
      .pipe(
        //catchError(this.handleError('getting dashboard counts'))
      );
  }
  getAppointmentDashboardDetails(createdDate,doctorId): any {
    return this.http.get<any>(this.fourscareService.baseTelecareURL() + "/dashboard/getAppointmentDashboardDetails/"+createdDate+"/"+doctorId)
      .pipe(
        //catchError(this.handleError('getting appointments details'))
      );
  }
  getDoctorDetailsById(doctorIds): any {
    return this.http.post<any>(this.fourscareService.baseTelecareURL() + "/dashboard/getDoctorsById/",doctorIds)
      .pipe(
        catchError(this.handleError('get doctor details'))
      );
  }
  getRegisteredPatientsByDateRange(startDate,endDate): any {
    return this.http.get<any>(this.fourscareService.baseTelecareURL() + "/dashboard/getRegisteredPatientCount/"+startDate+"/"+endDate)
      .pipe(
        catchError(this.handleError('getting dashboard counts'))
      );
  }
  
  getAllDoctors(): any {
    return this.http.get<any>(this.fourscareService.baseTelecareURL() + "/dashboard/getAllDoctors/")
      .pipe(
        catchError(this.handleError('getting all doctors'))
      );
  }
  updateDoctorStatusById(userId:String,isActiveStatus:Boolean,isVerifiedStatus:String,forusShare:String,forceUpdateValue:Boolean): any {

    return this.http.post<any>(this.fourscareService.baseTelecareURL() + "/dashboard/updateDoctorStatus/"+userId+"/"+isActiveStatus+"/"+isVerifiedStatus+"/"+forusShare+"/"+forceUpdateValue,{})
      .pipe(
        catchError(this.handleError('updating doctor status'))
      );
  }
  generateInvoice(startDateString,endDateString,userId,percentageDeduction): any {
    return this.http.get<any>(this.fourscareService.baseTelecareURL() + "/dashboard/generatePDFInvoive/"+startDateString+"/"+endDateString+"/"+userId+"/"+percentageDeduction)
      .pipe(
        catchError(this.handleError('generating invoice'))
      );
  }
  loadAllInvoicesByDateRangeAndDoctor(startDate:String,endDate:String,userId:Number){
    return this.http.get<any>(this.fourscareService.baseTelecareURL()+"/dashboard/getInvoicesByDateRangeAndDoctor/"+startDate+"/"+endDate+"/"+userId)
    .pipe(
      catchError(this.handleError('load all invoices by DateRange and doctor'))
    );
  }
  getInvoicesByDoctor(userId:Number){
    return this.http.get<any>(this.fourscareService.baseTelecareURL()+"/dashboard/getInvoicesByDoctor/"+userId)
    .pipe(
      catchError(this.handleError('load all invoices by doctor'))
    );
  }
  
  exportAppointmentDateWiseSplit(startDateString,endDateString,userId): any {
    return this.http.post<any>(this.fourscareService.baseTelecareURL() + "/dashboard/exportDatewiseCount/"+startDateString+"/"+endDateString+"/"+userId,{reponseType:"arraybuffer"})
      .pipe(
        catchError(this.handleError('export appointment excel'))
      );
  }
  getUploadedDocuments(userId:Number){
    return this.http.get<any>(this.fourscareService.baseTelecareURL()+"/api/userRecord/user/"+userId)
    .pipe(
      catchError(this.handleError('get doctor documents'))
    );
  }
  getBankDetailsByDoctorId(userId:Number){
    return this.http.get<any>(this.fourscareService.baseTelecareURL()+"/api/userAccount/user/"+userId)
    .pipe(
      catchError(this.handleError('get doctor bank details'))
    );
  }
  getlastDateOfDoctorAppointment(userId:any): any {
    return this.http.get<any>(this.fourscareService.baseTelecareURL() + "/api/appointment/getlastDateOfDoctorAppointment/"+userId)
      .pipe(
        catchError(this.handleError('get doctor appointment'))
      );
  }
}
